'use strict';

var _createForOfIteratorHelper = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _toConsumableArray = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var errcode = require('err-code');

var debug = require('debug');

var log = debug('libp2p:peer-store');
log.error = debug('libp2p:peer-store:error');

var _require = require('events'),
    EventEmitter = _require.EventEmitter;

var PeerId = require('peer-id');

var PeerInfo = require('peer-info');

var _require2 = require('../errors'),
    ERR_INVALID_PARAMETERS = _require2.ERR_INVALID_PARAMETERS;
/**
 * Responsible for managing known peers, as well as their addresses and metadata
 * @fires PeerStore#peer Emitted when a peer is connected to this node
 * @fires PeerStore#change:protocols
 * @fires PeerStore#change:multiaddrs
 */


var PeerStore = /*#__PURE__*/function (_EventEmitter) {
  _inherits(PeerStore, _EventEmitter);

  var _super = _createSuper(PeerStore);

  function PeerStore() {
    var _this;

    _classCallCheck(this, PeerStore);

    _this = _super.call(this);
    /**
     * Map of peers
     *
     * @type {Map<string, PeerInfo>}
     */

    _this.peers = new Map(); // TODO: Track ourselves. We should split `peerInfo` up into its pieces so we get better
    // control and observability. This will be the initial step for removing PeerInfo
    // https://github.com/libp2p/go-libp2p-core/blob/master/peerstore/peerstore.go
    // this.addressBook = new Map()
    // this.protoBook = new Map()

    return _this;
  }
  /**
   * Stores the peerInfo of a new peer.
   * If already exist, its info is updated. If `silent` is set to
   * true, no 'peer' event will be emitted. This can be useful if you
   * are already in the process of dialing the peer. The peer is technically
   * known, but may not have been added to the PeerStore yet.
   * @param {PeerInfo} peerInfo
   * @param {object} [options]
   * @param {boolean} [options.silent] (Default=false)
   * @return {PeerInfo}
   */


  _createClass(PeerStore, [{
    key: "put",
    value: function put(peerInfo) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        silent: false
      };

      if (!PeerInfo.isPeerInfo(peerInfo)) {
        throw errcode(new Error('peerInfo must be an instance of peer-info'), ERR_INVALID_PARAMETERS);
      }

      var peer; // Already know the peer?

      if (this.has(peerInfo.id)) {
        peer = this.update(peerInfo);
      } else {
        peer = this.add(peerInfo); // Emit the peer if silent = false

        !options.silent && this.emit('peer', peerInfo);
      }

      return peer;
    }
    /**
     * Add a new peer to the store.
     * @param {PeerInfo} peerInfo
     * @return {PeerInfo}
     */

  }, {
    key: "add",
    value: function add(peerInfo) {
      var _arguments = arguments,
          _this2 = this;

      if (!PeerInfo.isPeerInfo(peerInfo)) {
        throw errcode(new Error('peerInfo must be an instance of peer-info'), ERR_INVALID_PARAMETERS);
      } // Create new instance and add values to it


      var newPeerInfo = new PeerInfo(peerInfo.id);
      peerInfo.multiaddrs.forEach(function (ma) {
        return newPeerInfo.multiaddrs.add(ma);
      });
      peerInfo.protocols.forEach(function (p) {
        return newPeerInfo.protocols.add(p);
      });
      var connectedMa = peerInfo.isConnected();
      connectedMa && newPeerInfo.connect(connectedMa);
      var peerProxy = new Proxy(newPeerInfo, {
        set: function set(obj, prop, value) {
          if (prop === 'multiaddrs') {
            _this2.emit('change:multiaddrs', {
              peerInfo: obj,
              multiaddrs: value.toArray()
            });
          } else if (prop === 'protocols') {
            _this2.emit('change:protocols', {
              peerInfo: obj,
              protocols: Array.from(value)
            });
          }

          return Reflect.set.apply(Reflect, _toConsumableArray(_arguments));
        }
      });
      this.peers.set(peerInfo.id.toB58String(), peerProxy);
      return peerProxy;
    }
    /**
     * Updates an already known peer.
     * @param {PeerInfo} peerInfo
     * @return {PeerInfo}
     */

  }, {
    key: "update",
    value: function update(peerInfo) {
      if (!PeerInfo.isPeerInfo(peerInfo)) {
        throw errcode(new Error('peerInfo must be an instance of peer-info'), ERR_INVALID_PARAMETERS);
      }

      var id = peerInfo.id.toB58String();
      var recorded = this.peers.get(id); // pass active connection state

      var ma = peerInfo.isConnected();

      if (ma) {
        recorded.connect(ma);
      } // Verify new multiaddrs
      // TODO: better track added and removed multiaddrs


      var multiaddrsIntersection = _toConsumableArray(recorded.multiaddrs.toArray()).filter(function (m) {
        return peerInfo.multiaddrs.has(m);
      });

      if (multiaddrsIntersection.length !== peerInfo.multiaddrs.size || multiaddrsIntersection.length !== recorded.multiaddrs.size) {
        var _iterator = _createForOfIteratorHelper(peerInfo.multiaddrs.toArray()),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var _ma = _step.value;
            recorded.multiaddrs.add(_ma);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        this.emit('change:multiaddrs', {
          peerInfo: recorded,
          multiaddrs: recorded.multiaddrs.toArray()
        });
      } // Update protocols
      // TODO: better track added and removed protocols


      var protocolsIntersection = new Set(_toConsumableArray(recorded.protocols).filter(function (p) {
        return peerInfo.protocols.has(p);
      }));

      if (protocolsIntersection.size !== peerInfo.protocols.size || protocolsIntersection.size !== recorded.protocols.size) {
        var _iterator2 = _createForOfIteratorHelper(peerInfo.protocols),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var protocol = _step2.value;
            recorded.protocols.add(protocol);
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }

        this.emit('change:protocols', {
          peerInfo: recorded,
          protocols: Array.from(recorded.protocols)
        });
      } // Add the public key if missing


      if (!recorded.id.pubKey && peerInfo.id.pubKey) {
        recorded.id.pubKey = peerInfo.id.pubKey;
      }

      return recorded;
    }
    /**
     * Get the info to the given id.
     * @param {PeerId|string} peerId b58str id
     * @returns {PeerInfo}
     */

  }, {
    key: "get",
    value: function get(peerId) {
      // TODO: deprecate this and just accept `PeerId` instances
      if (PeerId.isPeerId(peerId)) {
        peerId = peerId.toB58String();
      }

      return this.peers.get(peerId);
    }
    /**
     * Has the info to the given id.
     * @param {PeerId|string} peerId b58str id
     * @returns {boolean}
     */

  }, {
    key: "has",
    value: function has(peerId) {
      // TODO: deprecate this and just accept `PeerId` instances
      if (PeerId.isPeerId(peerId)) {
        peerId = peerId.toB58String();
      }

      return this.peers.has(peerId);
    }
    /**
     * Removes the Peer with the matching `peerId` from the PeerStore
     * @param {PeerId|string} peerId b58str id
     * @returns {boolean} true if found and removed
     */

  }, {
    key: "remove",
    value: function remove(peerId) {
      // TODO: deprecate this and just accept `PeerId` instances
      if (PeerId.isPeerId(peerId)) {
        peerId = peerId.toB58String();
      }

      return this.peers.delete(peerId);
    }
    /**
     * Completely replaces the existing peers metadata with the given `peerInfo`
     * @param {PeerInfo} peerInfo
     * @returns {void}
     */

  }, {
    key: "replace",
    value: function replace(peerInfo) {
      if (!PeerInfo.isPeerInfo(peerInfo)) {
        throw errcode(new Error('peerInfo must be an instance of peer-info'), ERR_INVALID_PARAMETERS);
      }

      this.remove(peerInfo.id.toB58String());
      this.add(peerInfo); // This should be cleaned up in PeerStore v2

      this.emit('change:multiaddrs', {
        peerInfo: peerInfo,
        multiaddrs: peerInfo.multiaddrs.toArray()
      });
      this.emit('change:protocols', {
        peerInfo: peerInfo,
        protocols: Array.from(peerInfo.protocols)
      });
    }
    /**
     * Returns the known multiaddrs for a given `PeerInfo`. All returned multiaddrs
     * will include the encapsulated `PeerId` of the peer.
     * @param {PeerInfo} peer
     * @returns {Array<Multiaddr>}
     */

  }, {
    key: "multiaddrsForPeer",
    value: function multiaddrsForPeer(peer) {
      return this.put(peer, true).multiaddrs.toArray().map(function (addr) {
        var idString = addr.getPeerId();
        if (idString && idString === peer.id.toB58String()) return addr;
        return addr.encapsulate("/p2p/".concat(peer.id.toB58String()));
      });
    }
  }]);

  return PeerStore;
}(EventEmitter);

module.exports = PeerStore;